import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';

type ComparatorGridRowProps = {
  children: ReactNode | ReactNode[];
  containerClassName?: string;
};

export const ComparatorGridRow: React.FC<ComparatorGridRowProps> = ({ children, containerClassName }) => (
  <Box
    {...(containerClassName ? { className: containerClassName } : {})}
    sx={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 32px',
      gap: {
        xs: 1,
        md: 2,
      },
    }}
  >
    {children}
  </Box>
);
